import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {addressStyles} from './index.style'
import {useIntl} from 'react-intl'
import {pxToRem} from '../../utills/pxToRem'

const AddressDisplay = ({address, isCountryAdded, fontSize, showAddressName = true}) => {
    if (!address || Object.keys(address).length === 0) return null
    const {formatMessage} = useIntl()
    return (
        <Box sx={addressStyles} w="full">
            <Box display={'flex'} justifyContent={'space-between'} w="full" mb="8px">
                <Box>
                    {showAddressName && address.c_addressName && (
                        <Box
                            as="h3"
                            margin={0}
                            fontSize={{base: pxToRem(16), lg: pxToRem(18)}}
                            fontWeight={500}
                            letterSpacing={pxToRem(1)}
                            lineHeight={'normal'}
                            marginBottom={pxToRem(10)}
                            textTransform={'uppercase'}
                            wordBreak="break-all"
                        >
                            {address.c_addressName}
                        </Box>
                    )}
                </Box>
                <Box>
                    {showAddressName && address.preferred && (
                        <Box
                            as="h6"
                            margin={0}
                            fontSize={{base: pxToRem(10), lg: pxToRem(12)}}
                            fontWeight={500}
                            letterSpacing={pxToRem(2)}
                            lineHeight={'normal'}
                            marginBottom={pxToRem(10)}
                            backgroundColor={'cav_default_red'}
                            padding={pxToRem(5)}
                            color={'white'}
                        >
                            {formatMessage({
                                defaultMessage: 'DEFAULT',
                                id: 'shipping_address_selection.address.label.default'
                            })}
                        </Box>
                    )}
                </Box>
            </Box>
            <Text
                margin={0}
                textTransform={'capitalize'}
                fontSize={fontSize ? fontSize : {base: pxToRem(12), lg: pxToRem(13)}}
            >
                {address.firstName} {address.lastName}
            </Text>
            <Text margin={0} fontSize={fontSize ? fontSize : {base: pxToRem(12), lg: pxToRem(13)}}>
                {address.address1}
            </Text>
            <Text margin={0} fontSize={fontSize ? fontSize : {base: pxToRem(12), lg: pxToRem(13)}}>
                {address.city} {address.stateCode}, {address.postalCode}
            </Text>
            {isCountryAdded && (
                <Text
                    margin={0}
                    fontSize={fontSize ? fontSize : {base: pxToRem(12), lg: pxToRem(13)}}
                >
                    {formatMessage({
                        defaultMessage: 'United States',
                        id: 'shipping_address_selection.label.united_state'
                    })}
                </Text>
            )}

            <Text margin={0} fontSize={fontSize ? fontSize : {base: pxToRem(12), lg: pxToRem(13)}}>
                {address.phone}
            </Text>
        </Box>
    )
}

AddressDisplay.propTypes = {
    address: PropTypes.object,
    isCountryAdded: PropTypes.bool,
    fontSize: PropTypes.object,
    showAddressName: PropTypes.bool
}

export default AddressDisplay
